import React from 'react';
import { Eye, Edit, Trash2 } from 'lucide-react';
import { User } from '../types';
import { DataTable, Column } from '@components';

interface UsersTabProps {
  users: User[];
}

export const UsersTab: React.FC<UsersTabProps> = ({ users }) => {
  const userColumns: Column<User>[] = [
    {
      key: 'user',
      header: 'User',
      width: 'w-1/4',
      minWidth: 'min-w-[200px]',
      render: (user) => (
        <div className="flex items-center">
          <div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full">
            <span className="font-medium text-blue-600">{user.initials}</span>
          </div>
          <div className="ml-4">
            <div className="text-sm font-medium text-gray-900">{user.name}</div>
          </div>
        </div>
      ),
    },
    {
      key: 'email',
      header: 'Email',
      width: 'w-1/4',
      minWidth: 'min-w-[200px]',
    },
    {
      key: 'role',
      header: 'Role',
      width: 'w-1/6',
      minWidth: 'min-w-[100px]',
      render: (user) => (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
          user.role === 'Admin' ? 'bg-blue-100 text-blue-800' : 'bg-green-100 text-green-800'
        }`}>
          {user.role}
        </span>
      ),
    },
    {
      key: 'joinedDate',
      header: 'Joined',
      width: 'w-1/6',
      minWidth: 'min-w-[120px]',
    },
    {
      key: 'status',
      header: 'Status',
      width: 'w-1/6',
      minWidth: 'min-w-[100px]',
      render: (user) => (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
          {user.status}
        </span>
      ),
    },
    {
      key: 'actions',
      header: 'Actions',
      width: 'w-1/6',
      minWidth: 'min-w-[120px]',
      render: () => (
        <div className="flex space-x-2">
          <button className="text-blue-600 hover:text-blue-900" title="View">
            <Eye size={16} />
          </button>
          <button className="text-yellow-600 hover:text-yellow-900" title="Edit">
            <Edit size={16} />
          </button>
          <button className="text-red-600 hover:text-red-900" title="Delete">
            <Trash2 size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">Users Management</h2>
      </div>

      <DataTable
        data={users}
        columns={userColumns}
        emptyMessage="No hay usuarios disponibles"
      />
    </div>
  );
};
